import { gql } from '@apollo/client'

export const GET_NEED_FOR_ONBOARDING_QUERY = gql`
  query getNeedForOnboarding {
    getWorkspace {
      id
      isBrandSetupRequired
      canUserSetup
    }
  }
`
